module.exports = __webpack_public_path__ + "img/about_layout6.21c4300b.png";